import React from "react"
import Icon from "src/shared/icons"
import { RoomCardHeaderProps } from "../../../../interfaces/RoomCardHeaderProps"
import { useModulos } from "src/shared/hooks/useModulos"
import { formatTime } from "src/shared/utils/formatTime"

import "./RoomCardHeader.css"

const RoomCardHeader = ({
    iconName,
    roomTypeAbbreviation,
    roomNumber,
    iconBgColor = "var(--white)",
    hasIncidences,
    iconBgSecondaryColor,
    easyrewards,
    orderTimer,
}: Omit<RoomCardHeaderProps, "roomTypeName">) => {
    const { easyRewards: withEasyrewards } = useModulos()

    const textHeight = "20cqh"
    const iconWrapperHeight = "25cqh"
    const itemHeight = "20cqh"
    const itemTimerRSHeight = "16.75cqh"

    return (
        <div className="room-card-header--xs">
            <div className="room-card--xs-header__left__wrapper">
                <div
                    className="room-card--xs-header__icon-wrapper"
                    style={{
                        backgroundColor: iconBgColor,
                        height: iconWrapperHeight,
                        width: iconWrapperHeight,
                    }}
                >
                    <Icon
                        name={iconName}
                        width={itemHeight}
                        height={itemHeight}
                        color="var(--white)"
                        secondarycolor={iconBgSecondaryColor}
                    />
                </div>
                {!!orderTimer && (
                    <span className="room-card--xs-header__left__order-timer" style={{fontSize: itemTimerRSHeight}}>
                        {formatTime({ time: orderTimer, withHours: true })}
                    </span>
                )}
            </div>
            <span
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: "fit-content",
                    columnGap: "3px",
                }}
            >
                {easyrewards && withEasyrewards && (
                    <div className="gift-icon-wrapper">
                        <Icon
                            style={{
                                height: textHeight,
                            }}
                            name="giftFill"
                            color="var(--purple-drawer-primario)"
                        />
                    </div>
                )}
                {/* {!!hasIncidences && (
                    <Icon
                        name="alertFill"
                        color="var(--orange-warning)"
                        width={textHeight}
                        height={textHeight}
                        style={{
                            marginTop: 3,
                        }}
                    />
                )} */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex" }}>
                        {!!roomTypeAbbreviation && (
                            <span
                                className="room-card-header--xs__room-type-abbreviation"
                                style={{
                                    fontSize: textHeight,
                                }}
                            >
                                {roomTypeAbbreviation}-
                            </span>
                        )}
                        <span
                            className="room-card-header--xs__number"
                            style={{
                                fontSize: textHeight,
                            }}
                        >
                            {roomNumber}
                        </span>
                    </div>
                </div>
            </span>
        </div>
    )
}

export default RoomCardHeader
